import { render, staticRenderFns } from "./couponOrSubTransfer.vue?vue&type=template&id=4b176caa&scoped=true&"
import script from "./couponOrSubTransfer.vue?vue&type=script&lang=js&"
export * from "./couponOrSubTransfer.vue?vue&type=script&lang=js&"
import style0 from "./couponOrSubTransfer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./couponOrSubTransfer.vue?vue&type=style&index=1&id=4b176caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b176caa",
  null
  
)

component.options.__file = "couponOrSubTransfer.vue"
export default component.exports